import styled, { keyframes, css } from "styled-components";

const flyPlane = keyframes`
  0% {
    transform: translateX(-10px) translateY(0px) rotate(-2deg);
  }
  25% {
    transform: translateX(5px) translateY(-8px) rotate(0deg);
  }
  50% {
    transform: translateX(10px) translateY(0px) rotate(2deg);
  }
  75% {
    transform: translateX(5px) translateY(8px) rotate(0deg);
  }
  100% {
    transform: translateX(-10px) translateY(0px) rotate(-2deg);
  }
`;

const floatCloud = keyframes`
  0% {
    transform: translateX(0);
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(-400px);
    opacity: 0;
  }
`;

const floatCloudSlow = keyframes`
  0% {
    transform: translateX(0);
    opacity: 0.5;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    transform: translateX(-400px);
    opacity: 0;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  min-height: 60vh;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ContentCard = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  border-radius: 12px;
  box-shadow: 0 0 10px 0 ${({ theme }) => theme.palette.shadowSm};
  background-color: ${({ theme }) => theme.palette.white};
  text-align: center;
  position: relative;
  overflow: hidden;

  ${({ theme }) => theme.down("xs")} {
    padding: 30px 20px;
    border-radius: 8px;
  }
`;

export const IllustrationWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const SkyBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, ${({ theme }) => theme.palette.primarySubtle} 0%, ${({ theme }) => theme.palette.primarySubtle} 100%);
  border-radius: 12px;
`;

export const PlaneWrapper = styled.div`
  position: relative;
  z-index: 2;
  animation: ${css`${flyPlane}`} 4s ease-in-out infinite;

  & svg {
    width: 100px;
    height: 100px;
    filter: drop-shadow(2px 4px 6px ${({ theme }) => theme.palette.shadowSm});
  }
`;

export const Cloud = styled.div`
  position: absolute;
  top: ${({ top }) => top || "20%"};
  right: ${({ right }) => right || "-50px"};
  z-index: 1;
  animation: ${css`${floatCloud}`} ${({ delay }) => 8 + (delay || 0)}s linear infinite;
  animation-delay: ${({ delay }) => delay || 0}s;
  transform: scale(${({ size }) => size || 1});

  & svg {
    width: 60px;
    height: 40px;
    color: ${({ theme }) => theme.palette.white};
    filter: drop-shadow(0 2px 4px ${({ theme }) => theme.palette.shadowSm});
  }
`;

export const CloudSlow = styled.div`
  position: absolute;
  top: ${({ top }) => top || "50%"};
  right: ${({ right }) => right || "-80px"};
  z-index: 0;
  animation: ${css`${floatCloudSlow}`} ${({ delay }) => 12 + (delay || 0)}s linear infinite;
  animation-delay: ${({ delay }) => delay || 0}s;
  transform: scale(${({ size }) => size || 1});

  & svg {
    width: 80px;
    height: 50px;
    color: ${({ theme }) => theme.palette.whiteAlpha80};
    filter: drop-shadow(0 2px 4px ${({ theme }) => theme.palette.shadowSm});
  }
`;

export const ErrorCode = styled.div`
  font-size: 80px;
  font-weight: 800;
  background: linear-gradient(135deg, ${({ theme }) => theme.palette.searchButtonBg} 0%, #ff6b6b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  margin: 0;
  position: relative;
  z-index: 3;
  animation: ${css`${pulse}`} 3s ease-in-out infinite;

  ${({ theme }) => theme.down("xs")} {
    font-size: 60px;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.textPrimary};
  margin: 0;

  ${({ theme }) => theme.down("xs")} {
    font-size: 22px;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: ${({ theme }) => theme.palette.textSecondary};
  margin: 0;

  ${({ theme }) => theme.down("xs")} {
    font-size: 14px;
  }
`;

export const HomeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.searchButtonBg};
  color: ${({ theme }) => theme.palette.white};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    filter: brightness(90%);
    transform: translateY(-2px);
  }

  ${({ theme }) => theme.down("xs")} {
    font-size: 14px;
    padding: 12px 24px;
  }
`;
